import { SplitNodeEditor } from './SplitNodeEditor'
import { TimerNodeEditor } from './TimerEditor'
import EmailNodeEditor from './EmailNodeEditor'
import { MobileActionEditor } from './MobileActionEditor'
import CreateBannerEditor from './CreateBannerEditor'
import SettingsHeader from '../SettingsHeader'
import HubPopupNodeEditor from './HubPopupNodeEditor'
import AddToSegmentEditor from './AddToSegmentEditor'
import {
  AddToSegmentNode,
  BrowserPopupNotificationActionNode,
  BrowserPushNotificationActionNode,
  CreateCouponNode,
  CreateItemBannerActionNode,
  CreateUserStoreSettingsNode,
  CreateVirtualSKUNode,
  EmailActionNode,
  Node,
  SetAttributeValuesNode,
  SplitNode,
  TimerNode,
} from '@/api/dashboard'
import { BlockError, EventActionNodeType } from '../types'
import CreateCouponEditor from './CreateCouponEditor'
import BrowserPushEditor from './BrowserPushEditor'
import VirtualSKUEditor from '@/layouts/campaigns/editors/VirtualSKUEditor'
import InitStoreSettingsEditor from '@/layouts/campaigns/editors/InitStoreSettingsEditor'
import { SetUserAttributeEditor } from '@/layouts/campaigns/editors/SetUserAttributeEditor'
import { useContext } from 'react'
import { CampaignContext, ICampaignContext } from '@/expr/Context'
import { getDisabledClasses } from '@/layouts/campaigns/util'
import { cn } from '@dashboard/ui'
import { Badge } from '@/ui'

export const NodeFieldEditor = (props: {
  node: Node
  error?: BlockError | null
  onClose: () => void
  setNode: (node: Node) => void
}) => {
  const context = useContext(CampaignContext) as ICampaignContext
  let editor = <></>
  switch (props.node?.model_type) {
    case EventActionNodeType.AddToSegmentNode:
      editor = <AddToSegmentEditor error={props.error} node={props.node as AddToSegmentNode} setNode={props.setNode} />
      break

    case EventActionNodeType.CreateUserStoreSettingsNode:
      return (
        <InitStoreSettingsEditor
          error={props.error}
          onClose={props.onClose}
          node={props.node as CreateUserStoreSettingsNode}
          setNode={props.setNode}
        />
      )

    case EventActionNodeType.BrowserPopupNotificationActionNode:
      return (
        <HubPopupNodeEditor
          error={props.error}
          onClose={props.onClose}
          node={props.node as BrowserPopupNotificationActionNode}
          setNode={props.setNode}
        />
      )
    case EventActionNodeType.BrowserPushNotificationActionNode:
      editor = (
        <BrowserPushEditor
          error={props.error}
          node={props.node as BrowserPushNotificationActionNode}
          setNode={props.setNode}
        />
      )
      break
    case EventActionNodeType.EmailActionNode:
      editor = <EmailNodeEditor error={props.error} node={props.node as EmailActionNode} setNode={props.setNode} />
      break

    case EventActionNodeType.TimerNode:
      editor = <TimerNodeEditor error={props.error} node={props.node as TimerNode} setNode={props.setNode} />
      break

    case EventActionNodeType.MobilePushActionNode:
    case EventActionNodeType.MobilePopupActionNode:
      editor = <MobileActionEditor error={props.error} node={props.node} setNode={props.setNode} />
      break
    case EventActionNodeType.SplitNode:
      return (
        <SplitNodeEditor
          error={props.error}
          node={props.node as SplitNode}
          setNode={props.setNode}
          onClose={props.onClose}
        />
      )

    case EventActionNodeType.CreateItemBannerActionNode:
      return (
        <CreateBannerEditor
          error={props.error}
          onClose={props.onClose}
          node={props.node as CreateItemBannerActionNode}
          setNode={props.setNode}
        />
      )

    case EventActionNodeType.CreateCouponNode:
      return (
        <CreateCouponEditor
          error={props.error}
          node={props.node as CreateCouponNode}
          onClose={props.onClose}
          setNode={props.setNode}
        />
      )
    case EventActionNodeType.ItemOfferActionNode:
    case EventActionNodeType.ItemBonusOfferActionNode:
    case EventActionNodeType.ItemDiscountOfferActionNode:
    case EventActionNodeType.CreateVirtualSKUNode:
      return (
        <VirtualSKUEditor
          error={props.error}
          node={props.node as CreateVirtualSKUNode}
          onClose={props.onClose}
          setNode={props.setNode}
        />
      )

    case EventActionNodeType.SetAttributeValuesNode:
      return (
        <SetUserAttributeEditor
          error={props.error}
          node={props.node as SetAttributeValuesNode}
          onClose={props.onClose}
          setNode={props.setNode}
        />
      )
  }

  return (
    <div>
      <SettingsHeader node={props.node} onClose={props.onClose} />
      <div className={cn('p-6', getDisabledClasses(context.readOnly))}>
        {editor}
        <div style={{ height: '24px' }} />
        {props.error && props.error?.blockId == props.node?.id && (
          <Badge className="mt-2 capitalize" size={'sm'} variant={'red-primary'}>
            {props.error?.errorText}
          </Badge>
        )}
      </div>
    </div>
  )
}
